module.exports = __webpack_public_path__ + "img/Lee_Street_Part_2_0010.bb3f0c29.jpg";